import { FC } from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { useTranslation } from 'react-i18next';

type ChromeToggleFabProps = {
    chromeHidden: boolean;
    onToggle: () => void;
};

export const ChromeToggleFab: FC<ChromeToggleFabProps> = ({ chromeHidden, onToggle }) => {
    const { t } = useTranslation();
    const label = chromeHidden
        ? t('mobileProductCapture.chromeShow')
        : t('mobileProductCapture.chromeHide');

    return (
        <Tooltip title={label} placement="right">
            <IconButton
                className="mpc-chrome-fab"
                onClick={onToggle}
                aria-label={label}
                size="large"
            >
                {chromeHidden ? <MenuIcon /> : <MenuOpenIcon />}
            </IconButton>
        </Tooltip>
    );
};
